import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, message, Modal, Select } from 'antd'
import { bulkMergeBatches } from "../../../../services/api/3dApi"

class BatchMerge extends Component {
    state = {
        loading: false,
        open: false,
        location: 'MC'
    }

    _actionSendMerge = async () => {
        const { id, refreshBatchInfo } = this.props
        this.setState({
            loading: true
        })
        try {
            const payload = {
                list_batch_id: [id],
                location: this.state.location,
            }
            const { data: response } = await bulkMergeBatches(payload)
            const { success, data, error } = response

            if (!success) {
                message.error(error)
                return this.setState({
                    loading: false
                })
            }
            const { failed } = data
            if (failed.length > 0) {
                message.error(failed[0])
                return this.setState({
                    loading: false
                })
            }
            refreshBatchInfo()
            message.success('Lô đã chuyển sang trạng thái "pending" để bắt đầu quá trình xử lý file.')
            this._closeModal()
        } catch (e) {
            message.error(e.message)
        } finally {
            this.setState({
                loading: false
            })
        }
    }

    _showModal = () => {
        this.setState({ open: true })
    }

    _closeModal = () => {
        this.setState({ open: false })
    }

    _handleChangeLocation = (location) => {
        this.setState({ location })
    }

    render() {
        const { merge_file_status } = this.props
        const { loading, open, location } = this.state

        return (
            <>
                <Button icon="fund"
                    type=""
                    disabled={loading || (merge_file_status === 'pending' || merge_file_status === 'processing' || merge_file_status === 'retry')}
                    className='mr-3 mt-2'
                    onClick={this._actionSendMerge}
                >Xử lý file sản xuất</Button>

                <Modal
                    title="Xử lý file sản xuất"
                    visible={open}
                    onOk={this._actionSendMerge}
                    onCancel={this._closeModal}
                    footer={[
                        <Button onClick={this._closeModal}>Trở về</Button>,
                        <Button type="primary" onClick={this._actionSendMerge}>Xử lý</Button>
                    ]}
                >
                    <label className="font-weight-bold d-block">Chọn địa điểm</label>
                    <Select
                        placeholder={'Chọn địa điểm sản xuất'}
                        value={location}
                        onChange={this._handleChangeLocation}
                    >
                        <Select.Option value={"MC"}>MC Lab</Select.Option>
                    </Select>
                </Modal>
            </>
        )
    }
}

BatchMerge.propTypes = {
    id: PropTypes.string
}

export default BatchMerge
